import { GFAReference } from "@dune/types";
import { Button, ControlledInput } from "@dune/ui";
import { Plus, Trash2 } from "lucide-react";
import { useFormContext } from "react-hook-form";

interface GFAAutorisationsContainerProps {
	isForm?: boolean;
}

const GFAAutorisationsContainer = ({
	isForm = true,
}: GFAAutorisationsContainerProps) => {
	const { control, setValue } = useFormContext();
	const { watch } = useFormContext();
	const autorisations = watch("autorisations");
	return (
		<div className="flex flex-col gap-4">
			{isForm && (
				<div className="flex flex-row gap-4">
					<h1 className="text-[#144C65] text-lg font-medium">AUTORISATIONS</h1>
				</div>
			)}
			<div className="border rounded-lg p-4 flex flex-col gap-4">
				<div className="flex flex-col gap-4">
					{isForm ? (
						<div className="flex flex-row gap-4 w-[95%]">
							<div className="w-2/8">Type</div>
							<div className="w-2/8">N°</div>
							<div className="w-1/8">Date de délivrance </div>
							<div className="w-1/8">Constat d'affichage 1</div>
							<div className="w-1/8">Constat d'affichage 2</div>
							<div className="w-1/8">Constat d'affichage 3</div>
						</div>
					) : (
						<div className="flex flex-row gap-4 w-[95%]">
							<div className="w-1/2">Type</div>
							<div className="w-1/2">N°</div>
						</div>
					)}

					{autorisations?.map((autorisation: GFAReference, index: number) => (
						<div
							key={autorisation.id}
							className="flex flex-row gap-4 items-center"
						>
							{isForm ? (
								<>
									<div className="flex flex-row gap-4 w-[95%]">
										<div className="w-2/8">
											<ControlledInput
												name={`autorisations.${index}.type`}
												control={control}
											/>
										</div>

										<div className="w-2/8">
											<ControlledInput
												name={`autorisations.${index}.number`}
												control={control}
											/>
										</div>
										<div className="w-1/8">
											<ControlledInput
												name={`autorisations.${index}.issueDate`}
												control={control}
												type="date"
												formatThousands={true}
											/>
										</div>

										<div className="w-1/8">
											<ControlledInput
												name={`autorisations.${index}.displayReportDateOne`}
												control={control}
												type="date"
											/>
										</div>

										<div className="w-1/8">
											<ControlledInput
												name={`autorisations.${index}.displayReportDateTwo`}
												control={control}
												type="date"
											/>
										</div>

										<div className="w-1/8">
											<ControlledInput
												name={`autorisations.${index}.displayReportDateThree`}
												control={control}
												type="date"
											/>
										</div>
									</div>
									<Trash2
										onClick={() => {
											setValue("autorisations", [
												...autorisations.slice(0, index),
												...autorisations.slice(index + 1),
											]);
										}}
									/>
								</>
							) : (
								<>
									<div className="flex flex-row gap-4 w-[95%]">
										<div className="w-1/2">
											<ControlledInput
												name={`autorisations.${index}.type`}
												control={control}
												readOnly={true}
											/>
										</div>

										<div className="w-1/2">
											<ControlledInput
												name={`autorisations.${index}.number`}
												control={control}
												readOnly={true}
											/>
										</div>
									</div>
								</>
							)}
						</div>
					))}
					{isForm && (
						<Button
							onClick={() => {
								setValue("autorisations", [
									...autorisations,
									{ id: autorisations.length + 1 },
								]);
							}}
							variant="none"
							size="none"
							className="self-start"
							type="button"
						>
							<div className="flex flex-row items-center gap-2 font-medium text-sm text-primary">
								<Plus /> Ajouter
							</div>
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};

export default GFAAutorisationsContainer;
